import React, { Component, Fragment } from 'react';
import { Router, Route } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { signup } from "../../store/actions/authActions";
import queryString from 'query-string';
import validate from './validateOrganicSignup';
import { Card, Button, Alert, Row, Col } from 'react-bootstrap';
import { Input, FormFeedback, FormGroup, Label } from 'reactstrap';

class OrganicSignup extends Component {

       firstNamePlaceholder = "";
    surnamePlaceholder = "";
    passwordPlaceholder = "";
     confirmPasswordPlaceholder = "";
        marketingPlaceholder = "";
    registerButtonText = "";
    buttonClass = "";
    boxStyle = "";
  

    componentDidMount() {
        //const values = queryString.parse(this.props.location.search)
        //let email = values.email
     

        //this.setState({
        //    isSuccess: true,
            
        //})

    }

    handleFormSubmit(data) {
        //signup = ({ accountID, email, firstName, surname, password, marketing, isOrganic, partnerID }
        this.props.signup(data, this.props.isOrganic, this.props.account, this.onSubmitComplete.bind(this))

       // this.props.resetPassword(data, this.onSubmitComplete.bind(this));
    }

    onSubmitComplete() {

       // alert("Created");
      //  window.location.href = "https://demo-syed.maginepro.com/log-in";
        // this.props.history.push("/signin");
    }

    renderHidden = ({ input }) => {
        return (
            <input
                type="hidden"
                {...input}
            />
        );
    }

    renderTerms() {

        if (this.props.partnerName === "vivida") {
            return (
                <p><span className="terms-conditions"><i>By clicking “register account” you accept Vivida’s  <Link to={{ pathname: "https://www.kinoclub.com/terms-and-conditions" }} target="_blank">terms and conditions</Link> and <Link to={{ pathname: "https://www.kinoclub.com/app/privacy-policy" }} target="_blank">Privacy Policy</Link> </i></span></p>
            )
        } else {
            return (
                <p><span className="terms-conditions"><i>Ved at trykke Opret Konto accepterer du samtidig Kino Clubs <Link to={{ pathname: "https://www.kinoclub.com/terms-and-conditions" }} target="_blank">Brugerbetingelser</Link> og <Link to={{ pathname: "https://www.kinoclub.com/app/privacy-policy" }} target="_blank">Privatlivspolitik</Link> samt frasiger dig fortrydelsesretten.</i></span></p>)
        }

    }

    renderPartner() {
        var accountPlaceholder = "";
      

        switch (this.props.partnerName) {

            case "avisfordele":
                accountPlaceholder = "Kino Club ID";
                break;
            case "vios":
                accountPlaceholder = "VIOS medlems e-mail";
                break;
            case "sandrew":
                accountPlaceholder = "Sandrew medlems e-mail";
                break;
            case "norsk":
                accountPlaceholder = "Norsk medlems e-mail";
                break;
            case "panasonic":
                accountPlaceholder = "Panasonic medlems e-mail";
                break;
            case "kinoclubvip":
                accountPlaceholder = "Medlems e-mail";
                break;
            case "forbrugsforeningen":
                accountPlaceholder = "E-mail";
                break;
            case "hf":
                accountPlaceholder = "HF medlems e-mail";
                break;
            case "lff":
                accountPlaceholder = "LFF medlems e-mail";
                break;
            case "vivida":
                accountPlaceholder = "Your e-mail";
                this.firstNamePlaceholder = "First Name";
                this.surnamePlaceholder = "Last Name";
                this.passwordPlaceholder = "Choose Password";
                this.confirmPasswordPlaceholder = "Repeat Password";
                this.marketingPlaceholder = "I do not wish to receive marketing e-mails from Vivida or it’s associated partners";
                this.registerButtonText = "Register Account";
                this.buttonClass = "-btnLoginVivida";
                this.boxStyle = "mx-auto -vividaBox";
                break;
            default:
                accountPlaceholder = "Medlems ID"
        }



        if (this.props.requiresAccountID) {
            return (
                <div>
                    <div>
                        <Field
                            name="accountID"
                            component={renderTextField}
                            type="search"
                            autoComplete = "off"
                            placeholder={accountPlaceholder}
                        />
                    </div>
                    <div>
                        <Field
                            name="email"
                            component={renderTextField}
                            type="email"
                            placeholder="E-mail"
                        />
                    </div>
                </div>
            )
        } else {
            return(
            <div>
                <Field
                        name="email"
                        component={renderTextField}
                        type="email"
                        placeholder={this.props.logo !== "" ? accountPlaceholder : "E-mail"}

                />
            </div>
               )
        }
    }

    renderField = (
        { input, label, type, meta: { asyncValidating, touched, error } },
    ) => (
            <div>
                <div className={asyncValidating ? 'async-validating' : ''}>
                    <input {...input} type={type} placeholder={label} />
                    {touched && error && <span style={{ color: 'red' }}>
                        {error}
                    </span>}
                </div>
            </div>
        );


    renderForm(props) {
        const { handleSubmit } = props;

      

        if (this.props.auth.signupComplete) {
            return (
                
                <div className="signup-style">



                    <Card className="mx-auto">

                        <Card.Body>

                            <h3>Velkommen til Kino Club!</h3>
                            <span>For at komme godt i gang med din Kino Club oplevelse – <Link to={{ pathname: "https://play.kinoclub.com" }} target="_self">log ind nu</Link></span>
                     
                        </Card.Body>
                    </Card></div>
                
                );

        } else {
            return (
                
                <div className="signup-style">



                    <Card className={this.boxStyle !== "" ? this.boxStyle : "mx-auto"}>

                        <Card.Body>


                            <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>

                                {this.renderPartner()}

                                <div>
                                    <Field
                                        name="firstname"
                                        component={renderTextField}
                                        type="name"
                                        placeholder={this.firstNamePlaceholder !== "" ? this.firstNamePlaceholder : "Fornavn"}
                                    />
                                </div>
                                <div>
                                    <Field
                                        name="surname"
                                        component={renderTextField}
                                        type="name"
                                        placeholder={this.surnamePlaceholder !== "" ? this.surnamePlaceholder : "Efternavn"}
                                    />
                                </div>
                                <div>

                                    <div>
                                        <Field
                                            name="password"
                                            component={renderTextField}
                                            type="password"
                                            autocomplete="new-password"
                                            placeholder={this.passwordPlaceholder !== "" ? this.passwordPlaceholder : "Vælg kodeord"}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <Field
                                            name="confirmPassword"
                                            component={renderTextField}
                                            type="password"
                                            autocomplete="new-password"
                                            placeholder={this.confirmPasswordPlaceholder !== "" ? this.confirmPasswordPlaceholder : "Bekræft kodeord"}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <Field
                                            name="marketing"
                                            component={renderCheckboxField}
                                            type="checkbox"
                                            placeholder={this.marketingPlaceholder !== "" ? this.marketingPlaceholder : "Jeg ønsker ikke at marketing e-mails fra Kino Club eller dennes partnere"}
                                        />
                                    </div>

                                </div>
                                <div>
                                    <span style={{ color: 'red' }}>
                                        {this.props.auth.signup_error}
                                    </span>
                                </div>
                                <div className="btn-login-container">
                                    <Button className={this.buttonClass != "" ? this.buttonClass : "-btnLogin"} size="sm" type="submit" disabled={''}>
                                        {this.registerButtonText !== "" ? this.registerButtonText : "Opret konto" }  
                                    </Button>
                                    {this.renderTerms()}
                                   
                                </div>
                            </form>
                        </Card.Body>
                    </Card></div>
                
                
                );
        }
        

    }


    renderJFMLogos(props) {

        return (<div>
            <Row>
                <Col className="col-partner-support-logo"><span>Mangler du dit Kino Club ID? Du finder det i selvbetjeningen hos den avis du abonnerer på. Klik på din avis herunder og gå direkte til selvbetjeningen.</span></Col>


            </Row>
            <Row lg={3}>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.stiften.dk/#!/login" }} target="_blank"><img src={"/img/logos/A╠èrhus_Stiftstidende.png"} alt={"Århus Stiftstidende"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.avisendanmark.dk/#!/login" }} target="_blank"><img src={"/img/logos/Avisen Danmark.png"} alt={"Avisen Danmark"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.dagbladet-holstebro-struer.dk/#!/login" }} target="_blank"><img src={"/img/logos/Dagbladet_Holstebro_Struer.png"} alt={"Dagbladet Holstebro-Struer"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.dbrs.dk/#!/login" }} target="_blank"><img src={"/img/logos/Dagbladet_Ringk├╕bing_Skjern.png"} alt={"Dagbladet Ringkøbing-Skjern"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.folkebladetlemvig.dk/#!/login" }} target="_blank"><img src={"/img/logos/Folkebladet_Lemvig.png"} alt={"Folkebladet Lemvig"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.frdb.dk/#!/login" }} target="_blank"><img src={"/img/logos/Fredericia_Dagblad.png"} alt={"Fredericia Dagblad"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.fyens.dk/#!/login" }} target="_blank"><img src={"/img/logos/Fyens_Stiftstidende.png"} alt={"Fyens Stiftstidende"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.faa.dk/#!/login" }} target="_blank"><img src={"/img/logos/Fyns_Amts_Avis.png"} alt={"Fyns Amts Avis"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.helsingordagblad.dk/#!/login" }} target="_blank"><img src={"/img/logos/Helsing├╕r_Dagblad.png"} alt={"Helsingør Dagblad"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.hsfo.dk/#!/login" }} target="_blank"><img src={"/img/logos/Horsens_Folkeblad.png"} alt={"Horsens Folkeblad"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.jv.dk/#!/login" }} target="_blank"><img src={"/img/logos/JydskeVestkysten.png"} alt={"JydskeVestkysten"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.amtsavisen.dk/#!/login" }} target="_blank"><img src={"/img/logos/Randers_Amtsavis.png"} alt={"Randers Amtsavis"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.vafo.dk/#!/login" }} target="_blank"><img src={"/img/logos/Vejle_Amts_Folkeblad.png"} alt={"Vejle Amts Folkeblad"} className="logo-support" /></Link></Col>
                <Col className="col-partner-support-logo"><Link to={{ pathname: "https://selvbetjening.viborg-folkeblad.dk/#!/login" }} target="_blank"><img src={"/img/logos/Viborg_Stifts_Folkeblad.png"} alt={"Viborg Stifts Folkeblad"} className="logo-support" /></Link></Col>
        </Row></div>)

    }

    

    render() {
      //  const { handleSubmit } = this.props;
      
        return (

            <div >
              

                <div className="partner-logo">
                    <img src={this.props.logo} alt={this.props.partnerName} className="img-partner-logo"/>
                </div>

                {this.renderForm(this.props)}

                {this.props.partnerName == "avisfordele" ? this.renderJFMLogos(this.props)  :""} 


            </div>
        )
    }
}


const renderTextField = ({ placeholder, input, meta: { asyncValidating, touched, error, warning }, ...custom }) => {

    return (
        <Fragment>
            <FormGroup>
                <div className="field">

                    <Input placeholder=" " {...(touched ? { valid: !error } : {})} {...(touched ? { invalid: error } : {})} {...input} {...custom} />
                    <Label >{placeholder}</Label>
                    {touched && error && <FormFeedback>{error}</FormFeedback>}
                    </div>
                
            </FormGroup>
        </Fragment>
    )
};

const renderCheckboxField = ({ placeholder, input, meta: { asyncValidating, touched, error, warning }, ...custom }) => {

    return (
        <Fragment>
            <FormGroup>
                <div className="field">
                    <Label className="checkbox-label">{placeholder}</Label>
                    <Input className="checkbox-obj" placeholder=" " {...(touched ? { valid: !error } : {})} {...(touched ? { invalid: error } : {})} {...input} {...custom} />
                    
                    {touched && error && <FormFeedback>{error}</FormFeedback>}
                </div>

            </FormGroup>
        </Fragment>
    )
};

OrganicSignup = reduxForm({
    form: 'organicForm', // a unique identifier for this form,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(OrganicSignup);

function mapStateToProp(state, ownProps) {
    console.log(ownProps);
    const values = queryString.parse(ownProps.location.search)
    let email = values.email;
    let code = values.code;

    return {
        auth: state.auth,
        initialValues: { email: email},
        validate

    };
}

OrganicSignup = withRouter(connect(mapStateToProp, { signup })(withRouter(OrganicSignup)));


export default OrganicSignup;


// WEBPACK FOOTER //
// ./src/components/signup_partners/OrganicSignup.js